import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, Activity } from "lucide-react";

const ROLE_COLOR = { super_admin: "status-hot", manager: "status-warm", admin: "status-cold" };

function fmtChange(k, v) {
  const label = k.replace(/^data\./, "");
  const from = v?.from ?? "—";
  const to = v?.to ?? "—";
  return (
    <span className="font-mono text-[11px]">
      <span className="text-muted-foreground">{label}:</span>{" "}
      <span className="text-destructive line-through">{String(from).slice(0, 40)}</span>{" "}
      <span className="text-muted-foreground">→</span>{" "}
      <span className="text-[#32D74B]">{String(to).slice(0, 60)}</span>
    </span>
  );
}

export default function DataRecordsPage() {
  const [logs, setLogs] = useState([]);
  const [leads, setLeads] = useState({});
  const [q, setQ] = useState("");

  const load = async () => {
    const [{ data: l }, { data: ls }] = await Promise.all([
      api.get("/audit-logs", { params: { limit: 300 } }),
      api.get("/leads"),
    ]);
    setLogs(l);
    const map = {};
    (ls.items || []).forEach((x) => (map[x.id] = x));
    setLeads(map);
  };
  useEffect(() => { load(); }, []);

  const filtered = logs.filter((entry) => {
    if (!q) return true;
    const lead = leads[entry.lead_id];
    const name = lead?.data?.nama || lead?.data?.nim || "";
    const hay = `${entry.user_name} ${name} ${JSON.stringify(entry.changes)}`.toLowerCase();
    return hay.includes(q.toLowerCase());
  });

  return (
    <div className="space-y-5" data-testid="data-records-page">
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-muted-foreground">Audit</div>
        <h1 className="font-heading text-3xl font-bold text-white tracking-tight mt-1">Data Records</h1>
        <p className="text-sm text-muted-foreground mt-2">Riwayat perubahan lead — tanggal, oleh siapa, dan apa yang berubah.</p>
      </div>

      <Card className="bg-[#121212] border-border p-4 rounded-md">
        <div className="relative max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" strokeWidth={1.5} />
          <Input
            data-testid="records-search"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Cari nama lead, user, atau field..."
            className="pl-9 bg-[#0A0A0A] border-border"
          />
        </div>
      </Card>

      <Card className="bg-[#121212] border-border rounded-md overflow-hidden">
        <table className="w-full">
          <thead className="bg-[#0A0A0A] border-b border-border">
            <tr>
              <th className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground font-medium text-left px-4 py-3">Waktu</th>
              <th className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground font-medium text-left px-4 py-3">Oleh</th>
              <th className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground font-medium text-left px-4 py-3">Lead</th>
              <th className="text-[10px] tracking-[0.2em] uppercase text-muted-foreground font-medium text-left px-4 py-3">Perubahan</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={4} className="text-center py-12 text-muted-foreground text-sm">Belum ada catatan perubahan.</td></tr>
            ) : (
              filtered.map((entry) => {
                const lead = leads[entry.lead_id];
                return (
                  <tr key={entry.id} className="border-b border-border hover:bg-[#1C1C1E]">
                    <td className="px-4 py-3 font-mono text-xs text-muted-foreground whitespace-nowrap">
                      {new Date(entry.timestamp).toLocaleString("id-ID")}
                    </td>
                    <td className="px-4 py-3">
                      <div className="text-sm text-white">{entry.user_name}</div>
                      <span className={`inline-block px-1.5 py-0 rounded-sm text-[10px] font-mono mt-1 ${ROLE_COLOR[entry.user_role]}`}>
                        {entry.user_role.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-sm text-white">
                      {lead ? (lead.data?.nama || lead.data?.nim || lead.id.slice(-6)) : <span className="text-muted-foreground italic">deleted</span>}
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex flex-col gap-1">
                        {Object.entries(entry.changes || {}).map(([k, v]) => (
                          <div key={k}>{fmtChange(k, v)}</div>
                        ))}
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
